import { render, staticRenderFns } from "./ActualizarFactura.vue?vue&type=template&id=63fe405a&scoped=true"
import script from "./ActualizarFactura.vue?vue&type=script&lang=ts"
export * from "./ActualizarFactura.vue?vue&type=script&lang=ts"
import style0 from "./ActualizarFactura.vue?vue&type=style&index=0&id=63fe405a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fe405a",
  null
  
)

export default component.exports